import React, { useState } from "react";
import { formatCurrency } from "../../components/Constants/Constants";
import { AiOutlineDown, AiOutlineUp } from "react-icons/ai";
import AppLoader from "../../components/AppLoader/appLoader";
import "./MiscSettlement.css";
import { useMiscSettlementDetails } from "../../customHooks/MiscSettlement/useMiscSettlementDetails";
import { ArrowLeft } from "lucide-react";

function MiscSettlementDetails() {
  const { settlementId, settlementData, error, loading,handleGoBack } =
    useMiscSettlementDetails();

  if (loading) return <AppLoader />;

  return (
    <div>
      <div className="settlement-container d-flex flex-column mt-2">
         <button
                            className="btn btn-link text-primary p-0 d-flex align-items-center text-decoration-none me-3"
                            onClick={handleGoBack}
                            style={{ fontSize: "16px", fontWeight: "500" }}
                            aria-label="Go back to orders list"
                          >
                            <ArrowLeft size={20} style={{ marginRight: "5px" }} />
                            Back
                          </button>
        {/* Settlement Overview */}
        <div className="card card-custom mb-2">
          <div className="card-body">
            <div className="row g-4 mb-2">
              <div className="col-md-4 col-sm-6">
                <div className="settlement-overview-label">Settlement ID</div>
                <div className="settlement-overview-value">
                  {settlementData?.settlement_id}
                </div>
              </div>
              <div className="col-md-4 col-sm-6">
                <div className="settlement-overview-label">Client Id</div>
                <div className="settlement-overview-value">
                  {settlementData?.client_id}
                </div>
              </div>
              <div className="col-md-4 col-sm-6">
                <div className="settlement-overview-label">
                  Settlement Transaction ID
                </div>
                <div className="settlement-overview-value">
                  {settlementData?.settlement_txn_id}
                </div>
              </div>
            </div>
            <div className="row g-4">
              <div className="col-md-4 col-sm-6">
                <div className="settlement-overview-label">Settlement Type</div>
                <div className="settlement-overview-value">
                  {settlementData?.settlement_type}
                </div>
              </div>
              <div className="col-md-4 col-sm-6">
                <div className="settlement-overview-label">
                  Total Settled Amount
                </div>
                <div className="settlement-overview-value">
                  {formatCurrency(
                    settlementData?.order?.self?.amount?.value || 0
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex-fill px-4 overflow-auto">
          <div className="bg-white d-flex align-items-center justify-content-between mb-2">
            <h6 className="card-title fw-semibold">Settlement Details</h6>
          </div>

          {/* Seller and Provider Details */}
          <div className="card card-custom">
            <div className="card-body">
              <div className="row">
                {/* Seller Node Details */}
                <div className="col-md-6 mb-2">
                  <h6 className="fw-semibold mb-2 pb-1 border-bottom">
                   Futuresoft Settlement Details
                  </h6>
                  <div className="d-flex justify-content-between">
                    <span>Name:</span>
                    <span className="small">
                      {settlementData?.order?.self?.name}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span>Status:</span>
                    <span className="small">
                      {settlementData?.order?.self?.status}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span>Amount:</span>
                    <span className="fw-semibold text-success small">
                      {formatCurrency(
                        settlementData?.order?.self?.amount?.value || 0
                      )}
                    </span>
                  </div>
                  {settlementData?.order?.self?.error && (
                    <div className="d-flex justify-content-between">
                      <span>Error:</span>
                      <span className="small">
                        {settlementData?.order?.self?.error?.code}
                      </span>
                    </div>
                  )}
                </div>

                {/* Provider Details */}
                <div className="col-md-6 mb-2">
                  <h6 className="fw-semibold mb-2 pb-1 border-bottom">
                   Your Details
                  </h6>

                  <div className="d-flex justify-content-between">
                    <span>Provider Name:</span>
                    <span className="small">
                      {settlementData?.order?.provider?.name}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span>Status:</span>
                    <span className="small">
                      {settlementData?.order?.provider?.status}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span>Amount:</span>
                    <span className="fw-semibold text-success">
                      {formatCurrency(
                        settlementData?.order?.provider?.amount?.value || 0
                      )}
                    </span>
                  </div>
                  {settlementData?.order?.self?.error && (
                    <div className="d-flex justify-content-between">
                      <span>Error:</span>
                      <span className="small">
                        {settlementData?.order?.self?.error?.code}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Confirmation Modal */}
    </div>
  );
}

export default MiscSettlementDetails;
